import { NavLink } from "react-router-dom"
import React from 'react'
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../../redux/features/sidebarSlice";

const SideBarItem = (props) => {


    const dispatch = useDispatch()

    const closeSidebar = () => {
        dispatch(toggleSidebar(false))
    }

    let activeStyle= {
        backgroundColor: "#fdc51c",
        borderRadius: "5px",
    }
    
    return (
        <NavLink to={props.link} style={({isActive}) => isActive ? activeStyle : undefined} onClick={closeSidebar} className="text-dark text-decoration-none d-block p-2 my-2" exact="true">
            { props.img ? <img src={props.icon} className="pe-3" alt='icon' /> : <i className={"ri-"+props.icon+"-line ri-lg pe-3"}></i> }
            {props.name}
        </NavLink>
    )
}

export default SideBarItem
